import { InternalModule } from '../launch.constants';
import { ListItem, ListItemIcon, ListItemName, ListItemDescription } from '../styles';

interface HoverInfo {
  name: string;
  description: string;
  summary?: string;
  bullets?: string[];
  chipColors?: string[];
  color?: string;
  icon?: React.ElementType;
  kind: 'module' | 'tool';
}

interface ModuleRowProps {
  module: InternalModule;
  onOpen: (path: string) => void;
  onHover?: (info: HoverInfo | null) => void;
}

export const ModuleRow = ({ module, onOpen, onHover }: ModuleRowProps) => {
  const Icon = module.icon;
  return (
    <ListItem
      role="button"
      tabIndex={0}
      onClick={() => onOpen(module.path)}
      onKeyDown={(e) => e.key === 'Enter' && onOpen(module.path)}
      onMouseEnter={() => onHover?.({ name: module.name, description: module.description, summary: module.summary, bullets: module.bullets, chipColors: module.chipColors, color: module.color, icon: module.icon, kind: 'module' })}
      onMouseLeave={() => onHover?.(null)}
    >
      <ListItemIcon $color="#0ea5e9">
        <Icon size={18} strokeWidth={1.75} />
      </ListItemIcon>
      <ListItemName>{module.name}</ListItemName>
      <ListItemDescription>{module.description}</ListItemDescription>
    </ListItem>
  );
};

export type { HoverInfo };
